import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useResourceCount } from '../../../hooks/useResourceCount'

import Icon from '../../../components/ui/Icon'
import DayList from '../../../components/daysList/DayList'
import { Button } from '../../../components/buttons/Button'
import PageHeader from '../../../components/ui/pageHeader/PageHeader'
import { AllBookingList } from '../../../components/authenticated/management/booking/allBookings/AllBookingsList'

import { getDays } from '../../../utils/dateUtils'
import { MANAGEMENT_DAYS_AHEAD } from '../../../constants/booking'

const ManagerAllBookings = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('bookings')
  // No day picked by default: every booking, latest first.
  const [selectedDay, setSelectedDay] = useState<Date | null>(null)
  const { count: courtsNumber } = useResourceCount(
    '/api/v1/courts/count'
  )

  const days = getDays(new Date(), MANAGEMENT_DAYS_AHEAD + 1)

  const goTo = (path: string) => {
    navigate(path)
  }

  return (
    <>
      <PageHeader
        title={{
          eyebrow:
            courtsNumber === null
              ? undefined
              : t('booking.m.page-header.eyebrow', {
                  courtsNumber,
                }),
          h1: t('booking.m.page-header.title'),
        }}
        sub={t('booking.m.page-header.sub')}
        actions={[
          <Button
            key="new-booking"
            label={t('booking.m.page-header.actions.new-booking')}
            icon={<Icon name="plus" size={14} />}
            size="md"
            onClick={() => goTo('/m/booking')}
          />,
        ]}
      />
      <div className="row g-4">
        <div className="col-12">
          <DayList
            days={days}
            selectedDay={selectedDay}
            setSelectedDay={setSelectedDay}
            anyDay={{ disablePastDates: false }}
            onClear={() => setSelectedDay(null)}
          />
          {selectedDay === null && (
            <div className="muted small mt-8">{t('booking.m.all-days-hint')}</div>
          )}
        </div>
        <div className="col-12">
          <AllBookingList selectedDay={selectedDay} />
        </div>
      </div>
    </>
  )
}

export default ManagerAllBookings
